module.exports = __webpack_public_path__ + "static/flags/AU-3b86d74095b69dee811b40d41b166d16.gif";